import { render } from "./WeatherTrends.vue?vue&type=template&id=7b1bf54c"
import script from "./WeatherTrends.vue?vue&type=script&lang=js"
export * from "./WeatherTrends.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__